import { Box } from '@mui/material';

export function DashboardError() {
  return <Box>not found</Box>;
}
